module.exports = __webpack_public_path__ + "img/custom.538c1295.png";